<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel #itemTabPanel [selectedIndex]="0">
                <wj-tab *ngIf="item.id > 0">
                    <a>{{ 'user.listing_info' | transloco }}</a>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <fieldset [disabled]="mode == 'view'">
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.item_id' | transloco }}</label>
                                                    <div class="col-6 col-md-3">
                                                        {{item.id}}
                                                    </div>
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.event_date' | transloco }}</label>
                                                    <div class="col-6 col-md-3" *ngIf="item.auction">
                                                        {{item.auction.eventDate|date:'yyyy/MM/dd HH:mm'}}
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.venue' | transloco }}</label>
                                                    <div class="col-6 col-md-3" *ngIf="item.auction">
                                                        {{item.auction.place}}
                                                    </div>
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.lane' | transloco }}</label>
                                                    <div class="col-6 col-md-3" *ngIf="item.auction">
                                                        {{item.auction.lane}}
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.item_category' | transloco }}</label>
                                                    <div class="col-6 col-md-3">
                                                        {{item.category}}
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.auction_result' | transloco }}</label>
                                                    <div class="col-6 col-md-3">
                                                        {{item.auctionResult}}
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.item_name' | transloco }}</label>
                                                    <div class="col-6 col-md-9">
                                                        {{item.name}}
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.item_description' | transloco }}</label>
                                                    <div class="col-6 col-md-9">
                                                        {{item.description}}
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.quantity' | transloco }}</label>
                                                    <div class="col-6 col-md-3">
                                                        {{item.quantity}}{{item.unit}}
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.minimum_price' | transloco }}</label>
                                                    <div class="col-6 col-md-3">
                                                        {{item.minimumPrice|number}}
                                                    </div>
                                                    <label class="col-6 col-md-3 form-control-label">{{ 'user.start_price' | transloco }}</label>
                                                    <div class="col-6 col-md-3">
                                                        {{item.startPrice|number}}
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <gallery #imageGallery style="width: 100%;" [items]="galleryItems" thumbPosition="bottom"></gallery>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
</div>

